import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import styled from 'styled-components';

import Body2 from '@joinforma/ui/components/Body2';
import Title2 from '@joinforma/ui/components/Title2';

interface LinkContainerProps {
  selected?: boolean;
}

const LinkContainer = styled.div<LinkContainerProps>`
  &:hover {
    background-color: ${({ theme }) => theme.colors.background.tertiary};
  }
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding: 7px 0px;
  border-radius: 7px;
  background-color: ${({ selected }) =>
    selected ? ({ theme }) => theme.colors.background.tertiary : ''};
`;

const ItemContainer = styled.div`
  display: flex;
  gap: 10px;
  padding-left: 15px;
  align-items: center;
`;

const Text = styled(Body2)`
  display: block;
`;

const BoldText = styled(Title2)``;

const SideLink = ({
  active,
  category_id,
  children,
  start_icon,
  route,
  onClick,
}: {
  active?: boolean;
  category_id?: string;
  children: React.ReactNode;
  start_icon?: React.ReactNode;
  route: string;
  onClick?: () => void;
}) => {
  const location = useLocation();
  const pathname = location.pathname;

  // getting the category this way avoids overlaps between names like `food` and `food_services`
  const segments = pathname.split('/');
  const category_from_pathname =
    segments.length > 0 ? segments[segments.length - 1] : '';

  const isSelected = (
    pathname: string,
    route: string,
    category_id?: string,
    active?: boolean
  ) =>
    pathname.includes(decodeURIComponent(route)) ||
    category_from_pathname === category_id ||
    active;

  return (
    <LinkContainer
      onClick={onClick}
      selected={isSelected(pathname, route, category_id, active)}
    >
      <Link to={route}>
        <ItemContainer>
          {start_icon ? start_icon : null}
          {isSelected(pathname, route, category_id, active) ? (
            <BoldText>{children}</BoldText>
          ) : (
            <Text>{children}</Text>
          )}
        </ItemContainer>
      </Link>
    </LinkContainer>
  );
};

export default SideLink;
